import { useQuery } from "@tanstack/react-query";

/**
 * Stato di sblocco di un profilo Premium per l'utente corrente.
 *
 * Nel modello a crediti un profilo Premium va sbloccato (una volta sola, dal
 * suo profilo) prima di poterci chattare. Ogni superficie di chat usa questo
 * hook per sapere se disabilitare la scrittura, invece di duplicare la stessa
 * fetch in ogni componente.
 *
 * `applicable` è false fuori dal modello a crediti e sui profili non Premium:
 * in quel caso `locked` è sempre false e la UI resta invariata.
 */
export interface ProfileUnlockStatus {
  applicable: boolean;
  unlocked: boolean;
  cost: number;
  credits: number;
}

export function useProfileUnlockStatus(profileId?: string | null) {
  const { data, refetch, isLoading } = useQuery<ProfileUnlockStatus>({
    queryKey: ["/api/content/unlock-status", profileId],
    queryFn: async () => {
      const r = await fetch(`/api/content/unlock-status/${profileId}`, {
        credentials: "include",
      });
      if (!r.ok) throw new Error("unlock-status failed");
      return r.json();
    },
    enabled: !!profileId,
  });

  return {
    status: data,
    // Bloccato solo quando il controllo si applica E non è stato ancora pagato.
    locked: !!data?.applicable && !data.unlocked,
    cost: data?.cost ?? 0,
    refetch,
    isLoading,
  };
}
